import * as Types from '../../../../../graphql/__generated__/globalTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SearchCustomerForNewCustomerCreationForJobQueryVariables = Types.Exact<{
  searchTerm: Types.Scalars['String']['input'];
}>;


export type SearchCustomerForNewCustomerCreationForJobQuery = { __typename?: 'Query', searchCustomersBySearchTerm: { __typename?: 'SearchCustomersResponse', customers: Array<{ __typename?: 'SearchCustomerObject', createdAt: any, id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, secondaryPhoneNumber?: string | null, companyName?: string | null }> } };

export type SetCustomerForJobCustomerSelectionMutationVariables = Types.Exact<{
  customer: Types.CustomerInput;
}>;


export type SetCustomerForJobCustomerSelectionMutation = { __typename?: 'Mutation', upsertCustomer: boolean };


export const SearchCustomerForNewCustomerCreationForJobDocument = gql`
    query SearchCustomerForNewCustomerCreationForJob($searchTerm: String!) {
  searchCustomersBySearchTerm(searchTerm: $searchTerm) {
    customers {
      createdAt
      id
      firstName
      lastName
      email
      phoneNumber
      secondaryPhoneNumber
      companyName
    }
  }
}
    `;

/**
 * __useSearchCustomerForNewCustomerCreationForJobQuery__
 *
 * To run a query within a React component, call `useSearchCustomerForNewCustomerCreationForJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCustomerForNewCustomerCreationForJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCustomerForNewCustomerCreationForJobQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useSearchCustomerForNewCustomerCreationForJobQuery(baseOptions: Apollo.QueryHookOptions<SearchCustomerForNewCustomerCreationForJobQuery, SearchCustomerForNewCustomerCreationForJobQueryVariables> & ({ variables: SearchCustomerForNewCustomerCreationForJobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCustomerForNewCustomerCreationForJobQuery, SearchCustomerForNewCustomerCreationForJobQueryVariables>(SearchCustomerForNewCustomerCreationForJobDocument, options);
      }
export function useSearchCustomerForNewCustomerCreationForJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCustomerForNewCustomerCreationForJobQuery, SearchCustomerForNewCustomerCreationForJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCustomerForNewCustomerCreationForJobQuery, SearchCustomerForNewCustomerCreationForJobQueryVariables>(SearchCustomerForNewCustomerCreationForJobDocument, options);
        }
export function useSearchCustomerForNewCustomerCreationForJobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchCustomerForNewCustomerCreationForJobQuery, SearchCustomerForNewCustomerCreationForJobQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchCustomerForNewCustomerCreationForJobQuery, SearchCustomerForNewCustomerCreationForJobQueryVariables>(SearchCustomerForNewCustomerCreationForJobDocument, options);
        }
export type SearchCustomerForNewCustomerCreationForJobQueryHookResult = ReturnType<typeof useSearchCustomerForNewCustomerCreationForJobQuery>;
export type SearchCustomerForNewCustomerCreationForJobLazyQueryHookResult = ReturnType<typeof useSearchCustomerForNewCustomerCreationForJobLazyQuery>;
export type SearchCustomerForNewCustomerCreationForJobSuspenseQueryHookResult = ReturnType<typeof useSearchCustomerForNewCustomerCreationForJobSuspenseQuery>;
export type SearchCustomerForNewCustomerCreationForJobQueryResult = Apollo.QueryResult<SearchCustomerForNewCustomerCreationForJobQuery, SearchCustomerForNewCustomerCreationForJobQueryVariables>;
export const SetCustomerForJobCustomerSelectionDocument = gql`
    mutation SetCustomerForJobCustomerSelection($customer: CustomerInput!) {
  upsertCustomer(customer: $customer)
}
    `;
export type SetCustomerForJobCustomerSelectionMutationFn = Apollo.MutationFunction<SetCustomerForJobCustomerSelectionMutation, SetCustomerForJobCustomerSelectionMutationVariables>;

/**
 * __useSetCustomerForJobCustomerSelectionMutation__
 *
 * To run a mutation, you first call `useSetCustomerForJobCustomerSelectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCustomerForJobCustomerSelectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCustomerForJobCustomerSelectionMutation, { data, loading, error }] = useSetCustomerForJobCustomerSelectionMutation({
 *   variables: {
 *      customer: // value for 'customer'
 *   },
 * });
 */
export function useSetCustomerForJobCustomerSelectionMutation(baseOptions?: Apollo.MutationHookOptions<SetCustomerForJobCustomerSelectionMutation, SetCustomerForJobCustomerSelectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCustomerForJobCustomerSelectionMutation, SetCustomerForJobCustomerSelectionMutationVariables>(SetCustomerForJobCustomerSelectionDocument, options);
      }
export type SetCustomerForJobCustomerSelectionMutationHookResult = ReturnType<typeof useSetCustomerForJobCustomerSelectionMutation>;
export type SetCustomerForJobCustomerSelectionMutationResult = Apollo.MutationResult<SetCustomerForJobCustomerSelectionMutation>;
export type SetCustomerForJobCustomerSelectionMutationOptions = Apollo.BaseMutationOptions<SetCustomerForJobCustomerSelectionMutation, SetCustomerForJobCustomerSelectionMutationVariables>;